// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__9KMCn","navbar_brand":"header_navbar_brand__1Jj9_","logo":"header_logo__1Gafv","navbar_link":"header_navbar_link__iNI63"};